import { useId, type PropsWithChildren, type SelectHTMLAttributes } from "react";

interface SelectFieldProps extends SelectHTMLAttributes<HTMLSelectElement>, PropsWithChildren {
  label: string;
  error?: string | undefined;
  help?: string | undefined;
}

export function SelectField({ label, error, help, children, id: suppliedId, required, ...props }: SelectFieldProps) {
  const generatedId = useId();
  const id = suppliedId ?? generatedId;
  const describedBy = [help ? `${id}-help` : null, error ? `${id}-error` : null].filter(Boolean).join(" ") || undefined;
  return (
    <div className="form-group">
      <label htmlFor={id}>{label}{required && <span aria-hidden="true" className="text-danger"> *</span>}</label>
      <select {...props} id={id} required={required} aria-invalid={Boolean(error)} aria-describedby={describedBy} className={`form-control ${error ? "is-invalid" : ""}`}>{children}</select>
      {help && <small id={`${id}-help`} className="form-text text-muted">{help}</small>}
      {error && <div id={`${id}-error`} className="invalid-feedback">{error}</div>}
    </div>
  );
}
